import RelatedContentWithVisibilityToggle from '@rsa-digital/evo-shared-components/components/RelatedContent/RelatedContentWithVisibilityToggle';
import { ComponentProps } from '@rsa-digital/evo-shared-components/helpers/componentProps';
import { graphql } from 'gatsby';
import React from 'react';
import {
  processImageAsset,
  processReadMoreLink,
  unwrapSingleton,
} from 'helpers/csTypeProcessors';
import { ExpandableRelatedContentCardsData } from '../types';

export type ExpandableRelatedContentCardsProps = {
  expandable_related_content_cards: ExpandableRelatedContentCardsData;
} & ComponentProps;

export const query = graphql`
  fragment ExpandableRelatedContentCardsBlock on cs__expandable_related_content_cards {
    show_more_cta {
      ...Cta
    }
    show_less_cta {
      ...Cta
    }
    content_cards {
      ...RelatedContentCardBlock
    }
  }
`;

const ExpandableRelatedContentCards: React.FC<ExpandableRelatedContentCardsProps> = ({
  expandable_related_content_cards,
}) => {
  const formattedCards = expandable_related_content_cards.content_cards.map((card) => ({
    url: card.url,
    image: processImageAsset(card.image),
    heading: card.heading,
    subheading: card.subheading ?? undefined,
    body: card.body ?? undefined,
    readTime: card.read_time ?? undefined,
    readTimeText: card.read_time_text ?? undefined,
    readTimeIcon: unwrapSingleton(card.read_time_icon)?.icon_code,
    readMore: processReadMoreLink(card.read_more),
    maxLines: card.max_lines ?? undefined,
  }));
  return (
    <RelatedContentWithVisibilityToggle
      cardProps={formattedCards}
      ctas={{
        showMore: expandable_related_content_cards.show_more_cta,
        hide: expandable_related_content_cards.show_less_cta,
      }}
    />
  );
};

export default React.memo(ExpandableRelatedContentCards);
